import React, { useEffect, useState } from "react"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp"
import CheckOutlined from "@material-ui/icons/CheckOutlined"
import styled from "@emotion/styled"
import { colors } from "../../../../../../library/constants/styles/colors"
import ExpandableText
  from "../../../../../../components/expandableText/expandableText"
import InsertDriveFile from "@material-ui/icons/InsertDriveFile"
import { formatBytes } from "../../../../../../library/utils/fileSizeConverter"
import Button from "@material-ui/core/Button/Button"
import {
  generatePath,
  Link,
  useHistory,
  useParams,
  withRouter,
} from "react-router-dom"
import * as routes from "../../../../../../library/constants/routes"
import productLogoDefault from "../../../../../../assets/img/product.svg"
import { devices } from "../../../../../../library/constants/styles/responsive"
import { minutesToString } from "../../../../../../library/utils/timeConvert"
import returnExternalUrl
  from "../../../../../../library/utils/returnExternalUrl"
import { useDispatch } from "react-redux"
import { useAlert } from "../../../../../../hooks/useAlert"
import {
  createWork,
  finishWork,
  getKnowmix,
} from '../../../../../../library/store/actions/creators/knowmixCreators'
import StepTakeModal from '../../workModals/stepTakeModal'

const Container = styled.div`
  padding: 15px;
  border-radius: 2px;
  background-color: ${colors.white};
  box-shadow: 0 0 2px 0 ${colors.black12};
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  @media ${devices.xs} {
    flex-direction: column;
    align-items: flex-start;
  }

  p {
    max-width: 480px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media ${devices.xs} {
      max-width: 250px;
    }
  }
`

const Status = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.black54};

  span {
    margin-right: 15px;
  }
`

const Content = styled.div`
  padding-top: 15px;
`

const ContentItem = styled.div`
  &:not(:last-child) {
    margin-bottom: 15px;
  }
`

const ContentItemTitle = styled.p`
  margin-bottom: 8px;
  color: ${colors.black54};
`

const KnowmixStep = ({
  step,
  stepNumber,
  startKnowmix,
  knowmixFinished,
  isActive = false,
  canTakeQuiz = true,
}) => {
  const history = useHistory()
  const params = useParams()
  const { errorAlert } = useAlert()
  const dispatch = useDispatch()

  const [open, setOpen] = useState(isActive)

  const [isQuizOpen, setIsQuizOpen] = useState(false)

  useEffect(() => {
    if (isActive) setOpen(true)
  }, [isActive])

  const toggle = () => {
    setOpen(!open)
  }

  const handleFinishStep = async () => {
    if (step.type === 3) {
      return history.push(
        generatePath(routes.KNOWMIX_WALKTHROUGH, {
          knowmixId: params.knowmixId,
          stepId: stepNumber - 1,
        }),
      )
    }

    try {
      await dispatch(createWork({ step_id: step.id }))
      await dispatch(finishWork({ step_id: step.id }))
      await dispatch(getKnowmix({ id: parseInt(params.knowmixId) }))
    } catch (e) {
      if (e?.error?.code === 23401) {
        await dispatch(finishWork({ step_id: step.id }))
        await dispatch(getKnowmix({ id: parseInt(params.knowmixId) }))
      } else {
        errorAlert(e)
      }
    }
  }

  return (
    <Container>
      <Header onClick={toggle}>
        <p>
          Step {stepNumber} - {step.name}
        </p>
        <Status>
          {step.type === 3 && !!step.grade && (
            <CheckOutlined style={{ marginRight: 15 }} color={'primary'} />
          )}
          {canTakeQuiz && (
            <span>
              {step.type === 3 && 'Completed'}

              {step.has_questions ? (
                <>
                  {step.type === 2 && 'Not completed'}
                  {step.type === 1 && 'Not started'}
                </>
              ) : (
                <>{[1, 2].includes(step.type) && 'Not completed'}</>
              )}
            </span>
          )}
          {!open ? (
            <KeyboardArrowDown className='color-black-38' />
          ) : (
            <KeyboardArrowUp className='color-black-38' />
          )}
        </Status>
      </Header>
      {open && (
        <Content>
          {/*<p className={'color-primary mb15'}>Live meeting</p>*/}
          {/*<ContentItem>*/}
          {/*  <ContentItemTitle>Firm dates:</ContentItemTitle>*/}
          {/*  <ul className="text-list">*/}
          {/*    {['1 September 2021', '8 September 2021'].map((date, index) => (*/}
          {/*      <li key={date + index}>*/}
          {/*        <span>{date}</span>*/}
          {/*      </li>*/}
          {/*    ))}*/}
          {/*  </ul>*/}
          {/*</ContentItem>*/}
          {/*<ContentItem>*/}
          {/*  <ContentItemTitle>Learners number:</ContentItemTitle>*/}
          {/*  <span>10</span>*/}
          {/*</ContentItem>*/}
          {/*<ContentItem>*/}
          {/*  <ContentItemTitle>Physical location:</ContentItemTitle>*/}
          {/*  <span>Campus 10</span>*/}
          {/*</ContentItem>*/}
          {/*<ContentItem>*/}
          {/*  <ContentItemTitle>Virtual meeting link:</ContentItemTitle>*/}
          {/*  <span className={'color-primary'}>https://virtual.meeting</span>*/}
          {/*</ContentItem>*/}
          {/*<div className="h-divider h-divider--vertical-margin" />*/}
          <ContentItem>
            <ContentItemTitle>Step name:</ContentItemTitle>
            <span>{step.name}</span>
          </ContentItem>
          {!!step.description && (
            <ContentItem>
              <ContentItemTitle>Instructions:</ContentItemTitle>
              <ExpandableText text={step.description} limit={500} />
            </ContentItem>
          )}

          {!!step.time && (
            <ContentItem>
              <ContentItemTitle>Estimated time:</ContentItemTitle>
              <span>{minutesToString(step.time)}</span>
            </ContentItem>
          )}
          {/*{!!step.standards && step.standards.length > 0 && (*/}
          {/*    <ContentItem>*/}
          {/*        <ContentItemTitle>Standards</ContentItemTitle>*/}
          {/*        <ul className="text-list">*/}
          {/*            {step.standards.map(standard => <li key={standard.id}>{standard.name}</li>)}*/}
          {/*        </ul>*/}
          {/*    </ContentItem>*/}
          {/*)}*/}
          {!!step.links && step.links.length > 0 && (
            <ContentItem>
              <ContentItemTitle>Links:</ContentItemTitle>
              <ul className='text-list'>
                {step.links.map((link, index) => (
                  <li key={link + index}>
                    <a href={`${returnExternalUrl(link)}`} className='link'>
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </ContentItem>
          )}
          {!!step.blobs && step.blobs.length > 0 && (
            <ContentItem>
              <ContentItemTitle>Attachments:</ContentItemTitle>
              <div className='post__files'>
                {step.blobs.map(({ id, name, size, url }) => {
                  return (
                    <a
                      href={url}
                      target='_blank'
                      className='post__file'
                      key={id}
                    >
                      <InsertDriveFile
                        className='post__file-icon'
                        style={{ fontSize: '30px' }}
                      />
                      <div className='post__file-info'>
                        <span className='link link--inline'>{name}</span>
                        <span className='post__file-size'>
                          {formatBytes(size)}
                        </span>
                      </div>
                    </a>
                  )
                })}
              </div>
            </ContentItem>
          )}
          {/*{!!step.products && step.products.length > 0 && (*/}
          {/*  <ContentItem>*/}
          {/*    <ContentItemTitle>Products:</ContentItemTitle>*/}
          {/*    <div className='step-products'>*/}
          {/*      {step.products.map((item) => (*/}
          {/*        <div className='step-products__item' key={item.id}>*/}
          {/*          <Link*/}
          {/*            to={generatePath(routes.PRODUCT, { productId: item.id })}*/}
          {/*          >*/}
          {/*            <img*/}
          {/*              src={item.image || productLogoDefault}*/}
          {/*              alt='Product logo'*/}
          {/*              className='step-products__img'*/}
          {/*            />*/}
          {/*          </Link>*/}
          {/*          <Link*/}
          {/*            to={generatePath(routes.PRODUCT, { productId: item.id })}*/}
          {/*            className='step-products__name'*/}
          {/*          >*/}
          {/*            {item.name}*/}
          {/*          </Link>*/}
          {/*        </div>*/}
          {/*      ))}*/}
          {/*    </div>*/}
          {/*  </ContentItem>*/}
          {/*)}*/}
          {canTakeQuiz && (
            <ContentItem>
              {/*<ContentItemTitle>Test:</ContentItemTitle>*/}

              {/*<Button*/}
              {/*  onClick={() => setIsQuizOpen(true)}*/}
              {/*  color='primary'*/}
              {/*  variant='outlined'*/}
              {/*  disabled={!knowmixFinished}*/}
              {/*>*/}
              {/*  {step.type === 1 || step.type === 2*/}
              {/*    ? 'Complete'*/}
              {/*    : 'Review work'}*/}

              {/*  /!*Complete*!/*/}
              {/*</Button>*/}

              {step.has_questions ? (
                <Button
                  onClick={(_) => startKnowmix(stepNumber - 1)}
                  color='primary'
                  variant='outlined'
                  disabled={!knowmixFinished}
                >
                  {step.type === 1 || step.type === 2
                    ? 'Answer Question'
                    : 'Review work'}
                </Button>
              ) : (
                <Button
                  onClick={handleFinishStep}
                  color='primary'
                  variant='outlined'
                  disabled={!knowmixFinished}
                >
                  {step.type !== 3 ? 'Finish step' : 'Review work'}
                </Button>
              )}
            </ContentItem>
          )}
        </Content>
      )}
      {isQuizOpen && (
        <StepTakeModal
          stepId={step.id}
          open={isQuizOpen}
          onClose={() => setIsQuizOpen(false)}
        />
      )}
    </Container>
  )
}

export default withRouter(KnowmixStep)
